export default __webpack_public_path__ + "static/media/geofence.385dc9e0.png";